export default {
  name: 'seventh',
  data: function() {
    return {
      measurement_unit: {value: 'sqm', label: this.landingText.house_size_option_sqm[this.$route.params.id]},
      peopleNumber: 0,
      house_size_number: 0,
      houseAge: 0,
      validyear: true,
      validYearPipeFlag: false,
      hideReplacePipe: false
    }
  },
  props: ['landingText', 'people', 'water_damage', 'house_size', 'house_year', 'pipe_system_type', 'pipe_system_replace'],
  methods: {
    goToEighth: function() {
      this.pipe_system_replace.year = this.validYearPipeFlag === true ? parseInt(this.pipeAge) : null
      console.log('PIPE AGE: ' + this.pipe_system_replace.year)
      this.house_year.year = this.validyear === true ? parseInt(this.houseAge) : null
      this.$emit('change-component', 'eighth-component', this)
    },
    setNone: function() {
      this.water_damage.yes = false
      this.water_damage.no = false
    },
    unSetNone: function() {
      this.water_damage.unknown = false
    },
    setNonePipe: function(isDontKnow) {
      this.pipe_system_type.copper = false
      this.pipe_system_type.plastic = false
      this.pipe_system_type.composite = false
      if (isDontKnow) {
        this.pipe_system_type.none_of_above = false
      } else {
        this.pipe_system_type.dont_know = false
      }
    },
    unSetNonePipe: function() {
      this.pipe_system_type.dont_know = false
      this.pipe_system_type.none_of_above = false
    },
    validYear: function() {
      let currentYear = new Date().getFullYear()

      if (this.houseAge.length > 4) {
        this.validyear = false
        return
      }
      let _houseAge = parseInt(this.houseAge)
      if (_houseAge < 1000 || _houseAge > currentYear) {
        this.validyear = false
      } else {
        this.validyear = true
      }
    },
    validYearPipe: function() {
      let currentYear = new Date().getFullYear()
      if (this.pipeAge.length > 4) {
        this.validYearPipeFlag = false
        return
      }
      if (!/^\d+$/.test(this.pipeAge)) {
        this.validYearPipeFlag = false
        return
      }
      let _pipeYear = parseInt(this.pipeAge)
      if (_pipeYear > 1000 && _pipeYear <= currentYear) {
        this.validYearPipeFlag = true
      } else {
        this.validYearPipeFlag = false
      }
    }
  },
  watch: {
    peopleNumber: function() {
      if (this.peopleNumber < 0) {
        this.peopleNumber = 0
        this.people.number = this.peopleNumber
      } else {
        this.people.number = this.peopleNumber
      }
    },
    measurement_unit: function() {
      this.house_size.measurement_unit = (this.measurement_unit) ? (this.measurement_unit.value) : {value: 'sqm', label: this.landingText.house_size_option_sqm[this.$route.params.id]}
    },
    house_size_number: function() {
      if (this.house_size_number < 0) {
        this.house_size_number = 0
        this.house_size.house_size_number = this.house_size_number
      } else {
        this.house_size.house_size_number = this.house_size_number
      }
    }
  },
  beforeMount: function() {
    this.peopleNumber = this.people.number
    this.house_size_number = this.house_size.house_size_number
    if (this.house_size.measurement_unit) {
      if (this.house_size.measurement_unit === 'sqm') {
        this.measurement_unit = {value: 'sqm', label: this.landingText.house_size_option_sqm[this.$route.params.id]}
      } else if (this.house_size.measurement_unit === 'sqf') {
        this.measurement_unit = {value: 'sqm', label: this.landingText.house_size_option_sqf[this.$route.params.id]}
      }
    }
    this.houseAge = (this.house_year && this.house_year.year) ? this.house_year.year : 0
    this.pipeAge = this.pipe_system_replace.year != null ? this.pipe_system_replace.year : ''
    this.validYearPipe()
    this.hideReplacePipe = this.pipe_system_replace.year != null
  },
  mounted: function() {
    this.peopleNumber = this.people.number
    this.house_size_number = this.house_size.house_size_number
    if (this.house_size.measurement_unit) {
      if (this.house_size.measurement_unit === 'sqm') {
        this.measurement_unit = {value: 'sqm', label: this.landingText.house_size_option_sqm[this.$route.params.id]}
      } else if (this.house_size.measurement_unit === 'sqf') {
        this.measurement_unit = {value: 'sqm', label: this.landingText.house_size_option_sqf[this.$route.params.id]}
      }
    }
    this.houseAge = (this.house_year && this.house_year.year) ? this.house_year.year : 0
    this.pipeAge = this.pipe_system_replace.year != null ? this.pipe_system_replace.year : ''
    this.validYearPipe()
    this.hideReplacePipe = this.pipe_system_replace.year != null
  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/seventh/seventh.js